import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'wouter';
import { Colors } from '.';
import { LFC } from '../Legacy';

const Base = styled.div`
    display: flex;
    flex: 1 1 auto;
`;

const Title = styled.div`
    padding: .5rem 0;
    color: ${Colors.text};
    font-weight: 450;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    overflow: auto;
`;

const Menu = styled.div<{ expand?: boolean, width?: number }>`
    display: flex;
    flex-direction: column;
    flex: ${p => p.expand ? '1 1' : '0 0'} auto;   
    min-width: ${p => p.width ?? 12}rem;
    border-right: 2px solid #F0F2F5;
    padding: .5rem 0;
`;

const Button = styled.div<{ selected?: boolean }>`
    display: flex;
    align-items: center;
    padding: .5rem 2rem;
    color: ${Colors.text};
    cursor: pointer;

    &:hover {
        background: ${Colors.hover};
    }
    &:active {
        background: ${Colors.active};
    }

    ${p => !p.selected ? '' : css`
        color: ${Colors.primary};
        background: #F0F2F5;
    `}
`;

const Gap = styled.div`
    height: 2.5rem
`;

const LinkButton: LFC<{ to: any, selected?: boolean }> = ({ to, selected, children }) =>
    <Link to={to}><Button selected={selected}>{children}</Button></Link>;

export const VerticalTabSet = Object.assign(Base, {
    Menu,
    Button,
    Link: LinkButton,
    Gap,
    Content,
    Title,
});
